export const DEFAULT_API = '/api/-default-/public';

export const environment = {
  production: true,
  api: '/alfresco'
};

export const PERMISSIONS = {
  SiteCollaborator: {
    id: 'SiteCollaborator',
    value: 'Collaborateur'
  },
  SiteConsumer: {
    id: 'SiteConsumer',
    value: 'Lecteur'
  },
  SiteManager: {
    id: 'SiteManager',
    value: 'Gestionnaire'
  },
  SiteContributor: {
    id: 'SiteContributor',
    value: 'Contributeur'
  }
};
export const ENPERMISSIONS = {
  SiteCollaborator: {
    id: 'SiteCollaborator',
    value: 'Collaborater'
  },
  SiteConsumer: {
    id: 'SiteConsumer',
    value: 'Reader'
  },
  SiteManager: {
    id: 'SiteManager',
    value: 'Manager'
  },
  SiteContributor: {
    id: 'SiteContributor',
    value: 'Contributor'
  }
};

export const EDITOR_IFRAME = 'https://pulse-interne.synapture.fr/editeur/preview/';


export const GUTENBERG_URL = 'https://pulse-interne.synapture.fr'
export const V2NODE_URL = 'https://nodejs-interne.synapture.fr'; // TODO A vérifier
export const EASYBILL_URL = "https://pulse-interne.synapture.fr/easybill/getinvoice";

export const SERVER_URL = "https://pulse-interne.synapture.fr/python/file-upload";

export const CONECTOR_URL='https://pulse-interne.synapture.fr';

export const SITE_NAME = 'espace-documentaire';
export const SITE_UUID = 'f226d5dc-b3ee-466a-9448-5ccfebae2589';

export const PULSE_CMM="pulse-cmm"
export const CONNECTOR_URL='http://10.20.30.6:3001';
